export const getSelectableRoles = (availableRoles) => availableRoles.map(({ id, name, description, permissions }) => ({
    checkedValue: id,
    label: name,
    suggestion: description || `A role with ${permissions.length} permissions.`,
}));
